<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img alt="" src="images/jiadian_heightwo.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>太保家电雇主险+24小时-高空</h2>
					<div>行业首选方案 | 中国太平洋产险承保 | 不限厂商品牌</div>
					<div style="margin: 15px 0">
						<i class="el-icon-success" style="color: #409eff; font-size: 18px"></i>
						保障全天24小时发生的工作意外事故
						<br />
						<i class="el-icon-success" style="color: #409eff; font-size: 18px"></i>
						医疗费用高达30万，含自费药，零免赔
						<br />
						<i class="el-icon-success" style="color: #409eff; font-size: 18px"></i>
						可选第三者责任险，工单机器不属于保障范围
						<br />
						<i class="el-icon-error" style="color: red; font-size: 18px"></i>
						<span style="color: red">非工作原因导致的个人意外，不属于保障范围</span>
						<br />
						<i class="el-icon-error" style="color: red; font-size: 18px"></i>
						<span style="color: red">第三者财产损失每次事故免赔1000元或10%，取高者为准</span>
					</div>
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<avue-crud
						ref="crud"
						:cell-style="onCellStyle"
						:data="dataPlan"
						:option="optionPlan"
						:span-method="spanMethodPlan"></avue-crud>
				</el-card>
				<el-card header="赔付标准">
					<avue-crud ref="crud" :data="dataBenefit" :option="optionBenefit">
						<template slot="header"></template>
					</avue-crud>
				</el-card>
				<!--        <el-descriptions :column="1" border title="注意事项">-->
				<!--          <el-descriptions-item label="投保年龄">-->
				<!--            投保年龄限16-65周岁-->
				<!--          </el-descriptions-item>-->
				<!--          <el-descriptions-item label="可投保职业">-->
				<!--            本保单被保险人雇员为电梯/商业中央空调安装、运营、维护等（不含制造）相关人员-->
				<!--          </el-descriptions-item>-->
				<!--        </el-descriptions>-->
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="{question = '', answer = ''} in dataQA" :key="question">
								<div>
									<span
										style="
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ question }}</span>
								</div>
								<div style="display: flex; margin-top: 12px">
									<span
										style="
											width: 20px;
											height: 28px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>
									<div v-if="question === '中途是否可以加人？新增人员如何收费？'" style="display: inline-block">
										中途可以增加保障人员。新增人员时，根据该保单剩余的保障月数计算保费，剩余不足一个月的按一个月计算。
										<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
											<tr style="text-align: center">
												<th>剩余月数</th>
												<th v-for="item in 12">{{ item }}个月</th>
											</tr>
											<tr style="text-align: center">
												<td>支付比例</td>
												<td v-for="item in questionDataRate">{{ item }}</td>
											</tr>
										</table>
										保单2021年4月30日24点到期，批增人员2020年5月15日起保按照年度保费的100%收取，若批增人员在6月1日起保按照年度保费的95%收取。
									</div>
									<span v-else style="white-space: pre-wrap">{{ answer }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<div style="line-height: 26px; white-space: pre-line">
							<span style="font-weight: bold">
								本产品由中国太平洋财产保险股份有限公司（以下简称“太平洋产险”）承保，由太平洋产险委托博维保险经纪有限公司（以下简称“博维”）进行销售
							</span>
							（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
							太平洋产险成立于1991年，总部设在上海，注册资本为人民币194.70亿元。公司在拥有41家分公司，1家航运保险事业营运中心。截至2022年2季度，公司综合偿付能力充足率225.2%，满足监管要求，最近一期的风险综合评级结果为AA。
							<h3>一、重要告知</h3>
							<span style="font-weight: bold">
								1.1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。 1.2
								<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
								1.3 保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。 1.4
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
								1.5
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
								1.6
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，但应当退还保险费。
								1.7
								保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
							</span>
							<h3>二、产品信息</h3>
							<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
								<tr>
									<th style="width: 50%; padding: 5px 0">备案名称</th>
									<th style="width: 50%; padding: 5px 0">注册号</th>
								</tr>
								<tr style="text-align: center">
									<td style="padding: 5px 0">中国太平洋财产保险股份有限公司雇主责任保险（2016版）条款</td>
									<td style="padding: 5px 0">C00001430912016110806772</td>
								</tr>
							</table>
							<h3>三、产品介绍</h3>
							<span class="red-bold"></span>
							<h4>
								3.1本保险为“雇主责任保险”
								<span class="red-bold">（具体承保内容以保单及保险条款为准）</span>
								，针对家电行业的特征，我们对您投保本份保险作以下重要提示：
							</h4>
							3.1.1
							投保人或被保险人为中华人民共和国境内注册的企业或个体工商户，获得当地市场监督管理局颁发的《营业执照》。
							3.1.2
							<span class="red-bold">保障人员必须为接受被保险人（或保单约定的共同被保险人）派工及管理的人员。</span>
							<h4>3.2 投保人/被保险人</h4>
							家电行业企业为保险合同的投保人/被保险人。
							<h4>3.3 保险期限</h4>
							自所投保雇主责任保险生效日起，保险期限为一年。
							<h4>3.4 特别约定</h4>
							3.4.1本保险方案仅限家电行业企业投保。被保险人须按投保人员实际工作中危险程度最高的情况选择投保方案，若被保险人的在保人员在发生保险事故时实际工作的危险程度高于投保方案适用情况的，保险人将不承担任何赔偿责任。
							3.4.2在保险期间内，被保险人的在保人员因从事被保险人所安排的企业经营范围内的工作（不限家电品牌、品类）而遭受意外事故，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。
							3.4.3本保单保障项目分为死亡赔偿、伤残赔偿、医疗费用、误工费、第三者责任、法律费用，每项保障项目的赔偿限额以保单载明为准。
							3.4.4本保单采用记名承保，可承保人员包括正式在册职工、短期工、临时工、季节工、学徒工、负责人、法人代表、个体工商户经营者本人，以及被保险人的其他事实用工人员。保险人仅对记名投保人员清单中保障已生效的人员承担保险责任，对于不在保障已生效人员清单中的人员保险人不承担赔偿任何责任。
							3.4.5鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。在保单生效后申请退保或批减在保人员的，
							<span class="red-bold">可退保费为0。</span>
							3.4.6国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业”。保险人仅对投保高空方案的被保人员承担高处作业的保险责任，投保高空方案的在保人员从事高处作业发生的保险事故，保险人按照保险合同约定在赔偿限额内负责赔偿。
							3.4.7鉴于家电售后移动作业的行业特性，被保险人须在发生保险事故48小时内向保险人报案，且须提供包含派工单位、服务人员、服务时间、用户姓名、联系电话、服务地址等信息在内的不可逆的真实派工记录。否则，保险人有权拒赔或对无法核实保险责任的损失不承担赔偿责任。
							3.4.8在保险期间内，发生保险责任范围内的保险事故，导致在保人员死亡或伤残，保险人按下列标准赔偿：
							死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。伤残：根据伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级后，依据国家及当地社保部门规定的工伤伤残赔偿标准计算，并在保单约定的伤残赔偿限额内赔偿。保单约定的伤残赔偿以死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。为确保伤残鉴定结果准确无争议，在进行伤残鉴定前被保险人可提前联系保险人，确定保险人认可的伤残鉴定机构。对于伤残鉴定结果存在争议的，被保险人应前往当地劳动保障行政部门或保险人认可的伤残鉴定机构重新进行伤残鉴定。如出险人员可从工伤保险或其他途径获得伤残赔偿的，保险人将不承担该部分的赔偿责任或只承担工伤保险或其他赔偿不足部分。
							3.4.9
							<span class="red-bold">本保单特约伤残等级赔付限额比例：</span>
							一级100%；二级90%；三级80%；四级70%；五级60%；六级50%；七级40%；八级30%；九级20%；十级10%。该伤残等级赔付限额比例适用于本保单主险及附加险的各个部分。伤残项目对应《伤残鉴定标准》两项者，如果两项不同级，以级别高者确定伤残等级，如果两项同级，以该级别的上一等级确定伤残等级；伤残项目对应《伤残鉴定标准》三项以上者（含三项），以所有伤残项目中最高级别的上一等级确定伤残等级。但无论如何，伤残等级不得高于《伤残等级赔偿限额比例表》中所规定的一级。
							3.4.10医疗机构特别约定：本保单认可的医疗机构指经中华人民共和国卫生部门评审确定的二级或二级以上的医院，但不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构。该医院必须具有符合国家有关医院管理规则设置标准的医疗设备，且全天二十四小时有合格医师及护士驻院提供医疗及护理服务。如因紧急抢救无法前往本保单指定的定点医院救治的，应在情况允许的条件下，于72小时内转入本保单认可的医疗机构就诊。
							3.4.11医疗费用特别约定：本保单所约定的医疗费用赔偿责任仅包含在本保单认可的医疗机构发生且被保险人实际支出的，符合就诊地社会医疗保险主管部门规定的必要、合理、可报销的医疗费用，
							<span class="red-bold">
								但不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。
							</span>
							对被保险人所支出的符合本保单约定的医疗费用（包含门诊及住院）保险人均按100%比例给付。
							<span class="red-bold">
								如被保险人或出险人员已从其他途径获得补偿的，保险人只承担符合本保单约定的医疗费用剩余部分的保险责任。
							</span>
							3.4.12自费药品赔付特别约定：本保单在医疗费用项下扩展承保合理且必要的自费药品，保单约定的每人医疗费用责任限额不变。自费药品定义为：除社保甲、乙类用药以外的，合理且必须药品的自费部分，不包括各种营养滋补类的药品、保健品。
							3.4.13误工费赔付特别约定：在保险期间内，发生保险责任范围内的保险事故，导致在保人员暂时丧失工作能力并住院治疗的，经二级（含）以上或保险人认可的医疗机构提供合理的建议休息证明或由保险人依据《人身损害误工期、护理期、营养期评定规范》GA/T
							1193-2014，核定误工天数，保险人按照人民币100元/人/天的标准，以最长180天为限计算误工费。误工费计算包含住院期间以及出院后的休息误工时间，其中出院后休息误工时间取医嘱建休时间、实际误工时间及人身损害误工费评定标准三者中最短的时间，且一旦确定伤残程度后即刻停止误工费计算。如经过医疗机构诊断确定为永久丧失全部/部分工作能力的，应赔付误工费与根据前述伤残赔付约定所确定的伤残赔付金额合并在本保单赔偿限额内进行赔付，超出保单赔偿限额的部分保险人将不予赔付。误工费赔付无需被保险人提供出险人员的工资证明。
							<span class="red-bold">出险人员仅在门诊治疗的，无误工费赔付。</span>
							3.4.14扩展工伤事故：被保险人的在保人员在工作期间，由于工作原因受到伤害，依照《工伤保险条例》应当认定为工伤或视同工伤时，对于被保险人依法应承担的经济赔偿责任，保险人予以赔付。
							3.4.15扩展承保第三者责任：本保单扩展承保被保险人的在保人员在从事被保险人所安排的企业经营范围内的工作（不限家电品牌、品类）过程中，
							<span class="red-bold">
								因安装维修服务作业现场发生意外事故，并现场发现造成第三者的人身伤亡或直接财产损失，
							</span>
							根据《中华人民共和国民法典》及有关法律法规中关于民事侵权责任赔偿的相关规定，被保险人依法应承担的经济赔偿责任，保险人按照本条特别约定，在保险合同载明的本项扩展责任限额内负责赔偿。因火灾、爆炸、触电造成的意外事故，必须提供机器检测证明或厂家出具的事故原因鉴定结果。
							本项扩展责任下，保单累计赔偿限额RMB100万元，每次事故赔偿限额RMB60万元，其中每次事故人身伤亡赔偿限额RMB50万元，每次事故财产损失赔偿限额RMB10万元。同一网点投保多份保单，本项扩展责任的累计赔偿限额和每次事故赔偿限额均以单份保单限额为限，赔偿限额不可叠加。
							本扩展责任项下，每次事故财产损失绝对免赔额
							<span class="red-bold">为RMB1000元或损失金额的10%（两者取高者为准），</span>
							每次事故人身伤亡无免赔。
							<span class="red-bold">以下情况不属于第三者责任的保障范围：</span>
							(1)服务工单机器的损坏； (2)因服务工单机器本身及辅材的产品质量问题导致的第三者人身伤亡及财产损失；
							(3)冷库、冷却塔，以及非家电范畴的机电设备作业导致的财产损失；
							(4)因驾驶各种机动车辆（包括电动车）发生意外事故导致的第三者人身伤亡及财产损失；
							(5)装卸、运输货物期间发生意外事故导致的第三者人身伤亡及财产损失；
							(6)第三者直接财产损失不包含第三者要求被保险人赔偿的间接损失，例如交通费、住宿费等；
							(7)因机器安装维修不合格，导致二次上门服务所产生的机器安装维修费用；以及因安装设计和规范问题（开孔尺寸、安装位置、预留尺寸等）造成吊顶拆装、二次装修、破坏美观、客户退货等间接损失；
							(8)以下的第三者财产损失，保险公司不负赔偿责任：手机、手提电脑、相机等移动数码产品；珠宝、玉器、首饰、古玩、字画、艺术品、收藏品、稀有金属等珍贵财物以及无法鉴定价值的财产；动物、植物。
							<span class="red-bold">
								(9)无论工单是否完成，在保人员离开用户家后发生或发现的因安装维修导致的意外事故造成的第三者人身伤亡及财产损失。
							</span>
							本项扩展责任下，第三者是指除被保险人及其关联单位和关联人员以外的，被保险人的工作服务对象；或与被保险人、投保人员毫无任何关联关系(包括但不限于亲属、朋友、同事、合作伙伴等关系)的陌生人。
							3.4.16扩展法律费用条款：在保险期间内，发生可能引起本保险合同项下赔偿的情形时，被保险人被提起诉讼或仲裁，事先经保险人书面同意支付的合理的、必要的诉讼费、鉴定费、取证费、案件受理费、评估费、公证费、律师费、仲裁费及其他相关费用等，保险人依照本合同约定承担赔偿责任。保单累计赔偿限额为RMB10万元，每次事故赔偿限额为RMB10万元。
							3.4.17扩展24小时意外条款：扩展承保被保人员因主险条款第五条约定情形以外的意外伤害事故导致死亡、伤残和医疗费赔偿，保险人在对应保障项目的赔偿限额之内以被保险人实际赔偿金额为限承担赔偿责任；其中，伤残评定标准参照《人身保险伤残评定标准》（中保协发〔2013〕88号）评定，评定级别后赔偿金额计算标准同主险赔偿标准并以保单约定的死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。对于涉及第三方责任的情形，本扩展责任仅作为补充保障，按被保人员所承担的责任比例进行补充赔偿。
							除外责任:
							<span class="red-bold">(1)非工作原因（如游泳、戏水、游玩、娱乐和旅行等原因）导致的个人意外；</span>
							<span class="red-bold">(2)发生保险事故时被保人员实际工作的危险程度高于本产品适用情况的；</span>
							(3)本保单对以下原因直接或间接导致被保人员死亡或人身伤害不负赔偿责任：
							<span class="red-bold">战争、战乱、</span>
							反叛、罢工、暴乱、动乱以及核辐射等；疾病、传染病、生育、怀孕、医疗以及手术等；故意自残、自杀以及因药物或酒精导致的犯罪或失常行为；打架、酗酒、吸毒、以及精神错乱。
							本项扩展责任与主险条款内容相悖之处，以本条扩展责任的特约为准；未尽之处，以主险条款为准。
							<h4>3.5 责任免除</h4>
							<span class="red-bold">由于下列原因造成的任何损失、费用或赔偿责任，保险人不负责赔偿：</span>
							(1)投保人、被保险人或其法人、代理人的违法行为、犯罪行为、故意行为或重大过失行为；
							(2)战争、敌对行动、军事行动、武装冲突、罢工、暴动、民众骚乱、恐怖活动；
							(3)核辐射、核爆炸、核污染，或其他放射性、有毒、易爆物质的污染或影响； (4)行政行为、司法行为；
							(5)接触、使用石棉（包括石棉制品、石棉纤维等含有石棉成份的物质）或硅（包括硅产品、硅石粉尘等以任何形态存在的硅）；
							(6)传染病、分娩、流产、保单已承保的职业病以外的其他疾病（包括免疫系统疾病及精神疾病），以及因前述原因而接受医疗、诊疗。
							<span class="red-bold">
								保险事故发生时，被保险人的雇员存在下列情形之一，并因此导致人身损害的，保险人不承担赔偿责任：
							</span>
							（一）自杀、自残、打架、斗殴、受酒精或毒品的影响； （二）故意行为、违法行为、犯罪行为；
							（三）进行下列高风险运动、活动：
							1、从事潜水、登山、滑水、滑雪、滑冰、滑板、滑翔、跳伞、攀岩、蹦极或其他类似的极限运动； 2、进行探险活动；
							3、进行摔跤、柔道、空手道、跆拳道、拳击或其他类似的搏击运动； 4、进行需要经过特别训练的特技表演；
							5、参与任何职业、半职业或专业的体育运动；
							6、进行赛马、各种车辆表演、车辆竞赛或练习、驾驶卡丁车等高风险运动。
							（四）未遵医嘱，私自过量或不足量服用、涂用、注射药物或进行任何非治疗工伤所必须的手术；
							（五）无驾驶证，驾驶证失效或者被依法扣留、暂扣、吊销期间驾驶机动车，驾驶与驾驶证载明的准驾车型不相符合的机动车；
							（六）无国家有关部门核发的有效操作资格证而使用各种专用机械、特种设备或特种车辆或类似设备装置的；
							<span class="red-bold">下列损失、费用和责任，保险人不承担赔偿责任：</span>
							（一）被保险人对本合同生效前已发生事故的赔偿责任；
							（二）除本合同列明负责赔偿的项目外，其他超出被保险人职员所在地工伤保险和基本医疗保险诊疗项目目录、药品目录、医疗服务设施范围和支付标准的医疗费用；
							（三）精神损害赔偿及任何性质的罚款、罚金、惩罚性赔偿；
							（四）被保险人因合同或协议（含劳动合同、用工协议等）的约定而应承担的赔偿责任，但无该合同或协议的存在被保险人依法仍应承担的赔偿责任不受此限；
							（五）被保险人的任何间接损失； （六）被保险人应自行承担的免赔额。
							（七）被保险人员工因驾驶各种机动车辆（仅指领有公共牌照在公路上行驶的机动车辆）造成第三者人身伤亡或财产损失所引起的赔偿责任；
							（八）被保险人员工因从事医师、律师、会计师、建筑师、美容师等其他专门职业造成第三者人身伤亡或财产损失，所引起的赔偿责任。
							<span class="red-bold">其他不属于本保险责任范围内的损失、费用和责任，保险人不负责赔偿。</span>
							<h4>3.6 保单形式</h4>
							本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
							<h4>3.7 发票形式</h4>
							本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。
							<h3>四、理赔</h3>
							出险后请您尽快通过微信小程序“美保理赔助手”，或拨打博维客服热线400-180-1616进行报案，根据指引提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的损失进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
							<h3>五、其他信息</h3>
							5.1
							保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
							5.2
							若投保及后续服务和理赔过程中出现争议情况，您可致电博维客服热线400-180-1616或太平洋产险客户服务及投诉热线：95500，我们将安排专人跟进处理。
						</div>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {
	optionBenefit,
	optionPlanJiaDian,
	optionPremium,
	optionShortPeriodRate,
} from '@/const/crud/insurance/productDetail'

export default {
	name: 'Product31Details',
	data: function () {
		return {
			currentStep: '0',
			optionPlan: optionPlanJiaDian,
			optionPremium: optionPremium,
			optionBenefit: optionBenefit,
			optionShortPeriodRate: optionShortPeriodRate,
			dataPlan: [
				{
					insuredItem: '身故/伤残',
					plan1: '100万',
					plan2: '120万',
					plan3: '130万',
					plan4: '150万',
				},
				{
					insuredItem: '医疗费用',
					plan1: '30万(医保范围，含合理必须的自费药，100%赔付)',
				},
				{
					insuredItem: '误工费用',
					plan1: '100元/天（含住院期间以及出院后的休息误工时间，180天为限）',
				},
				{
					insuredItem: '法律费用',
					plan1: '10万',
				},
				{
					insuredItem: '24小时个人意外',
					plan1:
						'扩展在保人员全天24小时，因工作原因发生意外伤害事故导致死亡、伤残和医疗费赔偿。非工作原因导致的个人意外，不属于保障范围。',
				},
				{
					insuredItem: '基础版保费',
					plan1: '1338元/年',
					plan2: '1438元/年',
					plan3: '1538元/年',
					plan4: '1638元/年',
				},
				{
					insuredItem: '附加第三者责任（含新机完工责任）',
				},
				{
					insuredItem: '附加第三者责任',
					plan1:
						'含安装维修现场发生并发现的第三者财产损失及人员伤亡赔偿责任，<span class="red-bold">工单机器损失及特定财产不属于第三者保障范围。</span> <br/>' +
						'年度累计赔偿限额100万元，每次事故赔偿限额60万元，其中每次人身伤亡赔偿限额50万元，每次财产损失赔偿限额10万元。<br/>' +
						'每次事故财产损失免赔1000元或损失金额的10%，以高者为准。人身伤亡无免赔。',
				},
				{
					insuredItem: '需附加保费',
					plan1: '100元/年',
				},
			],
			dataBenefit: [
				{
					levelItem: '比例',
					level10: '10%',
					level9: '20%',
					level8: '30%',
					level7: '40%',
					level6: '50%',
					level5: '60%',
					level4: '70%',
					level3: '80%',
					level2: '90%',
					level1: '100%',
				},
			],
			dataShortPeriodRate: [
				{
					month1: '30%',
					month2: '40%',
					month3: '50%',
					month4: '55%',
					month5: '60%',
					month6: '70%',
					month7: '75%',
					month8: '80%',
					month9: '85%',
					month10: '90%',
					month11: '95%',
					month12: '100%',
				},
			],
			questionDataRate: ['10%', '20%', '30%', '45%', '50%', '60%', '70%', '80%', '85%', '90%', '95%', '100%'],
			dataQA: [
				{
					question: '雇主责任险的保险公司是哪家？',
					answer: '本雇主责任险产品是由中国太平洋保险股份有限公司承保的。',
				},
				{
					question: '保单和发票是电子版还是纸质的？',
					answer: '本方案提供有保险公司盖章的电子保单，另外根据投保单位需求可提供电子普票或纸质专票。',
				},
				{
					question: '保单如何查验真伪？',
					answer:
						'以下两种方式均可验真，方式1：在获取电子保单后登陆中国太平洋保险官网http://www.cpic.com.cn/，点击“服务大厅”-“电子保单验真与下载”-“电子保单验真”在“上传文件”处上传保单查验。方式2:拨打太平洋保险全国客服电话95500进行人工查询。',
				},
				{
					question: '对保障人员有要求吗？',
					answer:
						'只要是单位的雇员，且年龄在16-60周岁之间都可以，可承保人员包括正式在册职工、短期工、临时工、季节工、学徒工、负责人、法人代表和个体工商户经营者本人。',
				},
				{
					question: '中途是否可以换人？',
					answer: '在保险有效期内，被替换的员工无出险的前提下，可以替换，无需缴纳保费。',
				},
				{
					question: '中途是否可以加人？新增人员如何收费？',
					answer: '',
				},
				{
					question: '雇主责任险的保障范围有哪些？',
					answer:
						'在保险期间内，被保险人的在保员工在受雇过程中因从事被保险人所安排的企业经营范围内的工作（不限家电品牌、品类）而遭受意外事故，或患与业务有关的国家规定的职业性疾病，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。',
				},
				{
					question: '这个方案是否保障非被保险单位派工造成的第三者损失？',
					answer: '本方案不保障非被保险单位派工造成的第三者损失，非被保险单位派工仅保障在保人员（雇员）的人身意外。',
				},
				{
					question: '第三者是指哪些人？',
					answer:
						'第三者是指除被保险人及其关联单位和关联人员以外的，被保险人的工作服务对象；或与被保险人、投保人员毫无任何关联关系(包括但不限于亲属、朋友、同事、合作伙伴等关系)的陌生人。',
				},
				{
					question: '哪些情况不属于第三者责任险的保障范围？',
					answer:
						'1)服务工单机器的损坏；\n' +
						'2)因服务工单机器及辅材的产品质量问题导致的第三者人身伤亡及财产损失；\n' +
						'3)冷库、冷却塔，以及非家电范畴的机电设备作业导致的财产损失；\n' +
						'4)因驾驶各种机动车辆（包括电动车）发生意外事故导致的第三者人身伤亡及财产损失；\n' +
						'5)装卸、运输货物期间发生意外事故导致的第三者人身伤亡及财产损失；\n' +
						'6)第三者直接财产损失不包含第三者要求被保险人赔偿的间接损失，例如交通费、住宿费等；\n' +
						'7)因机器安装维修不合格，导致二次上门服务所产生的机器安装维修费用；以及因安装设计和规范问题（开孔尺寸、安装位置、预留尺寸等）造成吊顶拆装、二次装修、破坏美观、客户退货等间接损失；\n' +
						'8)以下的第三者财产损失，保险公司不负赔偿责任：手机、手提电脑、相机等移动数码产品；珠宝、玉器、首饰、古玩、字画、艺术品、收藏品、稀有金属等珍贵财物以及无法鉴定价值的财产；动物、植物；\n' +
						'9)无论工单是否完成，在保人员离开用户家后发生或发现的因安装维修导致的意外事故造成的第三者人身伤亡及财产损失。',
				},
				{
					question: '第三者责任险不负责赔偿哪些“特定财产”？',
					answer:
						'手机、手提电脑、相机等移动数码产品；珠宝、玉器、首饰、古玩、字画、艺术品、收藏品、稀有金属等珍贵财物以及无法鉴定价值的财产；动物、植物。',
				},
				{
					question: '对医疗机构有要求吗？',
					answer:
						'保险公司认可二级或以上的医院治疗，但不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构；如因紧急抢救无法前往本保单指定的定点医院救治的，应在情况允许的条件下，尽快在72小时内转入保险公司认可的医疗机构就诊',
				},
				{
					question: '门诊有没有误工费？',
					answer: '仅门诊治疗无误工费补偿。',
				},
				{
					question: '出院后的误工费怎么核算？',
					answer:
						'出院后休息误工时间会根据医嘱建休时间、实际误工时间及人身损害误工费评定标准三者中的最短时间进行核算，误工费是每天100元。',
				},
				{
					question: '造成第三者财产损失怎么赔偿？',
					answer:
						'按照保单特别约定，造成第三者物损每次事故绝对免赔1000元或损失金额的10%，以高者为准。另外，服务工单中本身的机器的损失与特定财产为除外责任，不属于保障范围。',
				},
				{
					question: '造成第三者伤残怎么赔偿',
					answer:
						'第三者伤残赔偿没有伤残等级限额标准，根据侵权责任计算相应赔偿金额，但不超过单次事故的三者人伤赔偿限额',
				},
				{
					question: '第三者财产损失保障中，每次事故免赔1000元或10%是什么意思？',
					answer:
						'简单来说，假如定损金额小于1000元，则保险公司最终赔付金额为0元。若定损金额在10000元以下，最终收到的赔款为定损金额减去1000元免赔； 若定损金额在10000元以上，扣除10%免赔，最终收到的赔款为定损金额的90%。',
				},
				{
					question: '非工作期间发生的意外能赔吗？',
					answer: '非工作原因导致的个人意外，例如游泳、戏水、游玩、娱乐和旅行等原因，不属于本方案的保障范围。',
				},
			],
		}
	},
	methods: {
		handleInsure() {
			this.$emit('insure')
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 1 || rowIndex === 2 || rowIndex === 3 || rowIndex === 4 || rowIndex === 7 || rowIndex === 8) {
				if (columnIndex === 1) {
					return [1, 4]
				}
			}
			if (rowIndex === 6) {
				if (columnIndex === 0) {
					return [1, 5]
				}
			}
		},
		onCellStyle({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 5 || rowIndex === 8) {
				if (columnIndex !== 0) {
					return {
						color: 'red',
						fontWeight: 'bold',
						fontSize: '18px',
					}
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}
</style>
